<template>
  <button class="collapse-btn">
    <span v-if="!hideText">Collapse</span>
    <svg-icon :icon="arrow" :width="7" :height="11"></svg-icon>
  </button>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon'
  import arrow from '@/assets/svg/arrow.svg'

  export default {
    components: {
      SvgIcon
    },
    props: {
      hideText: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        arrow
      }
    }
  }
</script>

<style lang="scss">
  .collapse-btn {
    @include naked-btn;
    display: inline;
    padding-right: 0;
    color: #FFFFFF;
    font-size: rem(14);
    margin-left: auto;

    &:focus {
      outline: 0;
    }

    svg {
      margin-left: rem(4);
      vertical-align: middle;
      fill: color(yellow);
    }
  }
</style>



// WEBPACK FOOTER //
// CollapseButton.vue?ff98142a